import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { t } from 'translation'
import LogoImg from 'assets/logo_white.png'
import { connect } from 'react-redux'
import { downloadCompanyLogo } from 'store/actions'
import { getNativeLocalPath } from '../../utils/conversion'

const Logo = ({ modClass, companyLogo, isOnline }) => {
  const ENV = process.env.NODE_ENV
  const logoBaseUrl =
    ENV === 'production'
      ? process.env.COMPANY_LOGO_URL_PRODUCTION
      : ENV === 'dev-remote'
      ? process.env.COMPANY_LOGO_URL_DEV_REMOTE
      : process.env.COMPANY_LOGO_URL_DEVELOPMENT

  let companyLogoUrl = `${logoBaseUrl}/${companyLogo}`

  if (window?.cordova && !isOnline && companyLogo) {
    const url = async () =>
      (companyLogoUrl = await getNativeLocalPath(`companyLogo/${decodeURI(companyLogo)}`))
  }

  return (
    <div className={`logo_img_w ${modClass}`}>
      {(companyLogo && isOnline) || localStorage.getItem('companyLogoDownloaded') ? (
        <>
          <div className="logo_img_in">
            <img
              loading="lazy"
              className="logo_img"
              src={companyLogoUrl}
              alt={t('general.YOUR_COMPANY_LOGO')}
            />
          </div>
          <div className="logo_divider"></div>
        </>
      ) : null}
      <Link className="logo_img_in" to="/">
        <img className="logo_img" src={LogoImg} alt="Sound Care" />
      </Link>
    </div>
  )
}

const mapStateToProps = ({ auth: { attributes, isOnline } }) => ({
  isOnline,
  companyLogo: attributes?.companyLogo,
})
const willMapDispatchToProps = {
  downloadCompanyLogo,
}

export default connect(mapStateToProps, willMapDispatchToProps)(Logo)

Logo.propTypes = {
  companyLogo: PropTypes.string,
  modClass: PropTypes.string,
}

Logo.defaultProps = {
  companyLogo: '',
  modClass: '',
}
